import { defineMessages } from 'react-intl';

export default defineMessages({
  done: {
    id: 'warranty_download.title1',
    defaultMessage: 'Done',
  },
  downloadComplete: {
    id: 'warranty_download.text1',
    defaultMessage: 'Download complete',
  },
});
